
<div>{{user.fname}} {{user.lname}} (user_id={{user.id}}, group_id={{user.group_id}})</div>